import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * DepartmentsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/departmentsApi/departmentsApi.service.js.
 *
 * Legacy used `/v1/api/departments` for mutations and `/v2/api/departments`
 * (rewritten via `.replace(/v1/, 'v2')`) for `list()`. Preserved.
 */
const DEPARTMENTS_BASE_V1 = "/v1/api/departments";
const DEPARTMENTS_BASE_V2 = "/v2/api/departments";

@Injectable({ providedIn: "root" })
export class DepartmentsApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(DEPARTMENTS_BASE_V2, {
        params: buildParams(props, PAGINATION_SEARCH_FIELDS),
      }),
    );
  }

  detail(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.get<unknown>(`${DEPARTMENTS_BASE_V1}/${id}`));
  }

  create(props: { name: string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(DEPARTMENTS_BASE_V1, { name: props.name }),
    );
  }

  update(props: {
    id: number | string;
    name: string;
  }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(DEPARTMENTS_BASE_V1, {
        id: props.id,
        name: props.name,
      }),
    );
  }

  remove(id: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.delete<unknown>(`${DEPARTMENTS_BASE_V1}/${id}`));
  }
}
